// **********************************************************
// Image Slider
// **********************************************************

const imageSlider = document.querySelectorAll('[data-slider="image-slider"]');

const imageSliderOptions = {
  slidesPerView: 'auto',
  speed: 400,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop: true,
  grabCursor: true,
  centeredSlides: true,
  effect: 'coverflow',
  coverflowEffect: {
    rotate: 0,
    scale: 0.77,
    stretch: 0,
    depth: 0,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      coverflowEffect: {
        stretch: -35,
      },
    },
  },
};

imageSlider.forEach((el) => {
  const imageSliderEle = el.closest('.image-slider');

  const arrowRight = imageSliderEle.querySelector('.arrow-right');
  const arrowLeft = imageSliderEle.querySelector('.arrow-left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, imageSliderOptions);
});
